import store from "@/store";

export const formatDateToYYYYMMDD = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month}-${day}`;
};

export const mapSmsStatus = (status) => {
  const allowed = ['sent', 'pending', 'failed'];
  return allowed.includes(status) ? status : '';
};

/**
 * Global permission checker
 */
export const checkPermission = (permission) => {
  const userPermissions =
    store.getters["app/userMenuPermissions"] || [];

  if (!Array.isArray(userPermissions)) {
    console.warn("userMenuPermissions is not an array", userPermissions);
    return false;
  }

  return userPermissions.includes(permission);
};
